import styles from "./common.module.scss"
import modalStyles from "../modals.module.scss"
import { OnboardingStep, useOnboardingStore } from "./model"
import { type ReactNode } from "react"
import { OnboardingModalSelectLanguage } from "./onboarding-select-language"
import { OnboardingModalSelectVoice } from "./onboarding-select-voice"

const STEP_TO_COMPONENT: Record<string, ReactNode> = {
  [OnboardingStep.SELECT_LANGUAGE]: <OnboardingModalSelectLanguage />,
  [OnboardingStep.SELECT_VOICE]: <OnboardingModalSelectVoice />,
}

export const OnboardingModal = () => {
  const step = useOnboardingStore(s => s.step)
  return (
    <div className={modalStyles.backdrop}>
      <div className={styles.wrapper}>{STEP_TO_COMPONENT[step]}</div>
    </div>
  )
}
